<template>
    <div>
        <div :class="imageType" class="banner" section="banner">
            <h1>{{ title }}</h1>
            <a v-if="cta" :href="cta.destination" class="btn primary regular cta-container">
                {{ cta.text }}
            </a>
        </div>

        <div class="care" section="care">
            <h2>{{ subtitle }}</h2>
            <div class="content">
                <p v-html="description" />
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'imageHeader',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        imageVars() {
            return {
                '--bg-xs': this.images.xs,
                '--bg-sm': this.images.sm,
                '--bg-md': this.images.md,
                '--bg-lg': this.images.lg
            }
        }
    },
    props: {
        title: {
            type: String,
            default: 'Movoto'
        },
        subtitle: {
            type: String,
            default: 'Jump-start your real estate journey with expert guidance'
        },
        description: {
            type: String,
            default: 'As you embark on your path to homeownership or consider your next home, we are here with the tools and assistance you need to move forward with knowledge and confidence.'
        },
        imageType: {
            type: String,
            default: 'default'
        },
        cta: {
            type: Object,
            default: null
        }
    },
};
</script>
<style lang="scss">
@use './imageHeader.scss' as *;
</style>

